/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ProductSummaryContent_product$ref = any;
import type { FragmentReference } from 'relay-runtime';
declare export opaque type ProductSummary_product$ref: FragmentReference;
export type ProductSummary_product = {|
  +$fragmentRefs: ProductSummaryContent_product$ref,
  +$refType: ProductSummary_product$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProductSummary_product",
  "type": "Product",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProductSummaryContent_product",
      "args": null
    }
  ]
};
(node/*: any*/).hash = '65353d3d440f78ce1b4d754c15e50561';
module.exports = node;



// WEBPACK FOOTER //
// ./src/views/Products/ProductSummary/__generated__/ProductSummary_product.graphql.js